module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/short-black-hair-smiling/short-black-hair-smiling@1x.png"